/**
 * HATA DEFTERI — sunucu ve arayuz AYNI hata tiplerini AYNI SIRADA kullanir
 *
 * ================================================================
 * NEDEN BURADA
 * ================================================================
 * Isi haritasinin sutun sirasi bir SUNUM DETAYI degil, bir
 * SOZLESMEDIR (F-MST-07): uzman iki ogrencinin haritasina yan yana
 * bakip "bu ogrencide dikkatsizlik daha koyu" diyebilmeli. Iki taraf
 * sirayi ayri ayri yazsaydi, biri degistigi gun ikisi ayrisir ve
 * KARSILASTIRMA sessizce yanlis olurdu — hicbir sey patlamaz, yalnizca
 * cikarilan sonuc yanlis olur. Bu, bu depoda en pahaliya patlayan
 * hata sinifi.
 *
 * Ayni sinif hata gercekten olmustu: panel "Baglanti 7 gun gecerlidir"
 * diyordu, sunucudaki deger 30 dakikaydi (bkz. `kimlik.ts`).
 */

/** Hata tipleri — `MistakeErrorType` enum'unun tam karsiligi (F-MST-02). */
export const HATA_TIPLERI = [
  "KNOWLEDGE_GAP",
  "CARELESS",
  "MISREAD",
  "CALCULATION",
  "TIME",
] as const;

export type HataTipi = (typeof HATA_TIPLERI)[number];

/**
 * Isi haritasinin SUTUN SIRASI — F-MST-07.
 *
 * `HATA_TIPLERI` ile ayni dizi ve bu BILEREK boyle: bugun sutun sirasi
 * ile tip listesi ayni. Ayri bir ad tasimasinin sebebi, ileride birinin
 * digerinden ayrilabilmesi degil, OKUYANIN hangi amacla kullandigini
 * bilmesi — "listede var mi" ile "kacinci sutun" ayri sorular.
 *
 * Sira ANLAMLI, alfabetik degil: once ogrenmeyle ilgili olanlar
 * (bilgi eksigi), sonra dikkatle ilgili olanlar, en sonda sinav
 * yonetimiyle ilgili olan (sure). Uzman soldan saga okurken
 * "calisma sorunu mu, sinav sorunu mu" ayrimini goruyor.
 */
export const HATA_TIPI_SIRASI = HATA_TIPLERI;

/** Kullaniciya gorunen Turkce karsiliklar — F-MST-02. */
export const HATA_TIPI_ADI: Readonly<Record<HataTipi, string>> = {
  KNOWLEDGE_GAP: "Bilgi eksiği",
  CARELESS: "Dikkat hatası",
  MISREAD: "Yanlış okuma",
  CALCULATION: "İşlem hatası",
  TIME: "Zaman yetmedi",
};

export function hataTipiGecerliMi(kod: string): kod is HataTipi {
  return Object.prototype.hasOwnProperty.call(HATA_TIPI_ADI, kod);
}

/**
 * KAPANMA İÇİN GEREKEN ARDIŞIK DOĞRU SAYISI — F-MST
 *
 * ================================================================
 * KURAL SUNUCUDA, CÜMLE EKRANDAYDI
 * ================================================================
 * `hata-defteri.ts` içindeki `tekrarCozuldu` "üst üste ikinci doğru"
 * kuralını uyguluyor. Öğrenci ekranı ise aynı kuralı kendi cümlesiyle
 * anlatıyordu: "Bir kez daha doğru çözersen kapanacak."
 *
 * Öğrenci oturumu 04.09.2026'da bunu bir **sürüklenme riski** olarak
 * bildirdi ve haklıydı: kural üçe çıkarılsaydı ekran yalan söylerdi ve
 * **istemci testi bunu göremezdi** — çünkü test de aynı cümleyi
 * doğrular. Aynı sınıf `haftaBasi`da bugün gerçekten oldu.
 *
 * Sayı ve cümle artık burada. Kural değiştiğinde metin de değişiyor.
 *
 * NOT: bu sabit `apps/api` içinde ZATEN vardı (aynı adla). Önce yeni
 * bir ad uydurdum (`KAPANMA_ARDISIK_DOGRU`) ve derleyici var olanı
 * gösterince geri aldım — üçüncü bir ad, çözmeye çalıştığım sorunun
 * kendisi olurdu. Sunucu artık bunu yeniden dışa veriyor.
 */
export const COZULDU_ICIN_ARDISIK_DOGRU = 2;

/**
 * Kapanmaya kaç doğru kaldığını anlatan cümle.
 *
 * `kalan` sıfırsa kapanmıştır ve bu fonksiyon çağrılmaz — çağıran
 * tarafın "kapandı" cümlesi ayrıdır.
 */
export function kapanmayaKalanMetni(kalan: number): string {
  return kalan === 1
    ? "Bir kez daha doğru çözersen kapanacak."
    : `${kalan} kez daha doğru çözersen kapanacak.`;
}
